import React from "react";
import translate from "../../../config/translations/translate";
import {
    Modal,
    UxSectionHeaderH3,
} from 'botbit-ui-components';
import {
    CloseIcon,
    LocalSEOIcon,
    ReputationIcon
} from './ActionableVideoModalIcons';
import './ActionableVideoModal.css';


const ActionableVideoModal = ({ videoURL, title, description, score, section="LOCAL_SEO", modalOpen, 
    onModalClose, onCancel, onCallToAction, t
}) => {

    return ( 
       
            <Modal isOpen={modalOpen} toggle={onModalClose} contentClassName={'actionable-video-modal-content'}>
            
                <div className="close-icon-container">
                        <CloseIcon onClick={onModalClose} />
                </div>
                <div className="elements-container">
                    <div className="header-container">
                        <UxSectionHeaderH3 
                            icon={ section === "LOCAL_SEO" ? <LocalSEOIcon/> : <ReputationIcon/>} 
                            title={section === "LOCAL_SEO" ? t('header.localSEO') : t('header.reputation') }
                        />
                    </div>
                    <div className="description-and-video-container">
                        <div className="description-container">
                            <h4 className="description-title"> {title} </h4>
                            <p className="description-text"> {description} </p>
                        </div>
                        <div className="video-container">
                    
                            <iframe className="video" 
                                title="actionableVideo" 
                                src={videoURL} 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                allowFullScreen>
                                    {t('errorVideoMessage')}
                            </iframe>
                        </div>
                    </div>
                    <div className="buttons-container">
                        <div className="score-increase-text-container">
                            <p className="score-increase-text"> {t('increaseValueMessage.firstPart')} </p>
                            <span className="highlight-span"> +{score}% </span>
                            <p className="score-increase-text"> {t('increaseValueMessage.secondPart')} <b>RAY</b> </p>
                        </div>
                        
                        <button className="request-button" onClick={onCallToAction}> {t('buttons.request')} </button>
                        <button className="cancel-button" onClick={onCancel}> {t('buttons.cancel')} </button>
                    </div>
                </div>
                   
            </Modal>
        
    )
}

ActionableVideoModal.translations = {
    header: {
        localSEO: {
            es: "Accionables Local SEO",
            en: "Actionable Local SEO"
        }, 
        reputation: {
            es: "Accionables Reputación",
            en: "Actionable Reputation"
        }
    },
    buttons: {
        request: {
            es: "Solicitar",
            en: "Request"
        },
        cancel: {
            es: "Cancelar",
            en: "Cancel"
        }
    }, 
    errorVideoMessage: {
        es: "Tu navegador no soporta el video.",
        en: "Your browser does not support the video."
    },
    increaseValueMessage: {
        firstPart: {
            es: "Vas a incrementar",
            en: "You are going to increase your value by"
        },
        secondPart: {
            es: "tu score en",
            en: "in"
        }   
    }
}

export default translate(ActionableVideoModal);
